import { defineMessages } from 'react-intl';

export const ColloquialSpecialtyIds = [
    '385', // Dietitian / Nutritionalist
    '386', // Eye Doctor
    '387', // Therapist / Counselor
    '388', // Hearing Specialist
    '398', // Infertility Specialist
];

export const ModalTypeIds = {
    PEDIATRIC: 1,
    URGENT_CARE: 2,
    OBGYN: 3,
    CROSS_LISTED: 4,
    ASSISTANT: 5,
    NATUROPATHIC: 6,
    ADDITIONAL_COPAY: 7,
    PHYSICIAN_ASSISTANT: 8,
    REFINE_PROCEDURE: 9,
};

// These modal types exclude the provider's specialty id from search if the user clicks 'No thanks'
export const ExclusionModalTypeIds = new Set([
    ModalTypeIds.CROSS_LISTED,
    ModalTypeIds.OBGYN,
    ModalTypeIds.PEDIATRIC,
    ModalTypeIds.PHYSICIAN_ASSISTANT,
]);

export const LOCALIZED_ASSISTANT_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.Assistant.Header',
        defaultMessage: 'Continue booking?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.Assistant.Message',
        defaultMessage: 'This appointment is with a healthcare professional under the supervision of '
            + '{provider}. You may not be seen directly by {provider}.',
    },
});

export const LOCALIZED_ADDITIONAL_COPAY_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.AdditionalCopay.Header',
        defaultMessage: 'Please note that you may be charged an additional fee when you book with this practice.',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.AdditionalCopay.Message',
        defaultMessage: '',
    },
});

export const LOCALIZED_CROSS_LISTED_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.CrossListed.Header',
        defaultMessage: 'Do you want to see {relevantSpecialtyWithArticle}?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.CrossListed.Message',
        defaultMessage: '{provider} is {relevantSpecialtyWithArticle} (not {searchSpecialtyWithArticle}), but '
            + 'they do treat patients for the reason you selected ({procedure}).',
    },
});

export const LOCALIZED_NATUROPATHIC_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.Naturopathic.Header',
        defaultMessage: 'Do you want to see a Naturopathic Doctor (ND)?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.Naturopathic.Message',
        defaultMessage: '{provider} practices naturopathic medicine, which is a type of alternative medicine. NDs are licensed practitioners, but receive different training than Medical Doctors (MDs) or Osteopathic Physicians (DOs).',
    },
});

export const LOCALIZED_OBGYN_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.Obgyn.Header',
        defaultMessage: 'Do you want to see an OBGYN?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.Obgyn.Message',
        defaultMessage: '{provider} is an OBGYN. This kind of doctor usually sees female patients.',
    },
});

export const LOCALIZED_PEDIATRIC_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.Pediatric.Header',
        defaultMessage: 'Are you making a pediatric appointment?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.Pediatric.Message',
        defaultMessage: '{provider} only sees children and adolescents.',
    },
});

export const LOCALIZED_PHYSICIAN_ASSISTANT_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.PhysicianAssistant.Header',
        defaultMessage: 'Do you want to see a Physician Assistant?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.PhysicianAssistant.Message',
        defaultMessage: '{provider} is a Physician Assistant (who practices under the supervision of a licensed physician) (not a Primary Care Doctor), but does treat patients for the reason you selected ({procedure}).',
    },
});

export const LOCALIZED_REFINE_PROCEDURE_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.RefineProcedure.Header',
        defaultMessage: '{provider} needs to know the reason for your visit.',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.RefineProcedure.Message',
        defaultMessage: 'I am seeing the doctor for',
    },
    ADDITIONAL_MESSAGE: {
        id: 'Search.Page.Components.Constraints.RefineProcedure.AdditionalMessage',
        defaultMessage: 'Sorry, {provider} does not see patients for {procedure}.',
    },
});

export const LOCALIZED_URGENT_CARE_TEXT = defineMessages({
    HEADER: {
        id: 'Search.Page.Components.Constraints.UrgentCare.Header',
        defaultMessage: 'Do you want to see an urgent care doctor?',
    },
    MESSAGE: {
        id: 'Search.Page.Components.Constraints.UrgentCare.Message',
        defaultMessage: 'You may be seen by a different practitioner than the one you choose.',
    },
    ADDITIONAL_MESSAGE: {
        id: 'Search.Page.Components.Constraints.UrgentCare.AdditionalMessage',
        defaultMessage: 'Your insurance copay may be higher at this practice.',
    },
});

export const LOCALIZED_MODAL_PRIMARY_ACTION_TEXT = defineMessages({
    BOOK_APPOINTMENT: {
        id: 'Search.Page.Components.Constraints.BookAppointment.Message',
        defaultMessage: 'Book this Appointment',
    },
    YES: {
        id: 'Search.Page.Components.Constraints.Yes.Message',
        defaultMessage: 'Yes',
    },
    OK_CONTINUE_BOOKING: {
        id: 'Search.Page.Components.Constraints.OkContinue.Message',
        defaultMessage: 'OK, continue booking',
    },
});

export const LOCALIZED_MODAL_SECONDARY_ACTION_TEXT = defineMessages({
    DEFAULT: {
        id: 'Search.Page.Components.Constraints.Default.SecondaryActionText',
        defaultMessage: 'No thanks',
    },
    CANCEL: {
        id: 'Search.Page.Components.Constraints.Cancel.SecondaryActionText',
        defaultMessage: 'Cancel',
    },
});

export const LOCALIZED_FIND_A_DOCTOR = defineMessages({
    DEFAULT: {
        id: 'Search.Page.Components.Constraints.FindADoctor',
        defaultMessage: 'Find a doctor who will see me for {procedure}',
    },
});

export const LOCALIZED_PLEASE_SELECT = defineMessages({
    DEFAULT: {
        id: 'Search.Page.Components.Constraints.PleaseSelect',
        defaultMessage: 'Please Select',
    },
});
